module.exports = __webpack_public_path__ + "img/saving.ec5227a8.jpg";